import { useLocation } from 'react-router';

function RedirectComponent ()
{
    const location = useLocation();
    const baseUrl = `${process.env.REACT_APP_BASE_URL}`;

    const isPaymentCallback = location.pathname === '/pay-response';

    if (!isPaymentCallback && window?.location?.href?.includes(`${process.env.REACT_APP_CLOUDFRONT_URL}`))
    {
        console.log("Navigating to home redirect component");
        window.location.replace(baseUrl);
    }

    return <div></div>;
}

export default RedirectComponent;